const SESSION_KEY = "rogo_impersonated_email";

export function getImpersonatedEmail(): string | null {
	return sessionStorage.getItem(SESSION_KEY) || null;
}

export function setImpersonatedEmail(email: string): void {
	sessionStorage.setItem(SESSION_KEY, email);
}

export function clearImpersonatedEmail(): void {
	sessionStorage.removeItem(SESSION_KEY);
}
